<template>
    <div :key="renderKey">
        <v-expansion-panels>
            <draggable v-model="rowscopy" :disabled="!$root.edit || rows.length == 1" @change="save" tag="ContentsContainer">
                <v-expansion-panel v-for="(row,rowindex) in rows" :key="row.id || rowindex">
                    <v-expansion-panel-header v-zoezi-editable="{setProp: (value) => row.name = value, html: false, multiline: false}">
                        {{row.name}}
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                        <component-wrapper
                            :config="row"
                            :array="rows"
                            can-remove
                        />
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </draggable>
        </v-expansion-panels>
    </div>
</template>

<script>
import Draggable from 'vuedraggable';
import {omitBy} from 'lodash';
import components from '../component.js'
export default {
    name: 'zoezi-expansionpanel',

    zoezi: {
        title: 'Expansion panel',
        icon: 'mdi-chevron-down'
    },

    components: {
        Draggable,
    },

    props: {
        rows: {
            title: 'Rows',
            type: Array,
            default: () => [components.makeEmptyConfig({name: window.$translate('New row')})],
            fulltype: 'namelist',
            typeinfo: {
                getNewName: (rows) => {
                    const newRowName = window.$translate('New row');
                    let numNew = rows.filter(x => x.name.startsWith(newRowName)).length;
                    let suffix = numNew == 0 ? '' : (' ' + (numNew+1));

                    return newRowName + suffix;
                }
            }
        }
    },
    data: () => ({
        renderKey: 0,
        rowscopy: null
    }),
    methods: {
        save() {
            const props = omitBy(this.$props, v => v === undefined)
            props.rows = this.rowscopy;
            this.$emit('save', props);
            ++this.renderKey;
        }
    },
    created() {
        this.rowscopy = this.rows;
    }
}
</script>
